__turbopack_context__.v({
  "btn_group": "HeaderSection-module-scss-module__axXPDa__btn_group",
  "header": "HeaderSection-module-scss-module__axXPDa__header",
  "header_bg": "HeaderSection-module-scss-module__axXPDa__header_bg",
  "header_bg_carousel": "HeaderSection-module-scss-module__axXPDa__header_bg_carousel",
  "header_bg_img": "HeaderSection-module-scss-module__axXPDa__header_bg_img",
  "header_bg_picture": "HeaderSection-module-scss-module__axXPDa__header_bg_picture",
  "header_bg_slider": "HeaderSection-module-scss-module__axXPDa__header_bg_slider",
  "header_btn": "HeaderSection-module-scss-module__axXPDa__header_btn",
  "header_btn_wrapper": "HeaderSection-module-scss-module__axXPDa__header_btn_wrapper",
  "header_content": "HeaderSection-module-scss-module__axXPDa__header_content",
  "header_desc": "HeaderSection-module-scss-module__axXPDa__header_desc",
  "header_info": "HeaderSection-module-scss-module__axXPDa__header_info",
  "header_info_item": "HeaderSection-module-scss-module__axXPDa__header_info_item",
  "header_info_label": "HeaderSection-module-scss-module__axXPDa__header_info_label",
  "header_info_value": "HeaderSection-module-scss-module__axXPDa__header_info_value",
  "header_inner": "HeaderSection-module-scss-module__axXPDa__header_inner",
  "header_sub_title": "HeaderSection-module-scss-module__axXPDa__header_sub_title",
});
